/*
 *
 *  UsersFormDialogContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { UsersFormDialog } from './index';
import { USERS_DATA_TABLE, USERS_FORM_DIALOG } from './constants';
import { executeBlockAction } from './actions';
import {
    makeSelectCurrentRecord,
    makeSelectRowSelection,
    makeSelectSelection,
} from 'containers/AdvancedDataTable/selectors';
import { makeSelectMode } from 'containers/AdvancedFormDialog/selectors';


class UsersFormDialogContainer extends React.Component {

    render() {
        return (
            <div>
                <UsersFormDialog
                    onBlock={this.props.executeBlockAction}
                    {...this.props}
                />
            </div>
        );
    }
}

UsersFormDialogContainer.propTypes = {
    executeBlockAction: PropTypes.func.isRequired,

};

const mapStateToProps = createStructuredSelector({
    mode: makeSelectMode(USERS_FORM_DIALOG),
    currentRecord: makeSelectCurrentRecord(USERS_DATA_TABLE),
    selection: makeSelectSelection(USERS_DATA_TABLE),
});

function mapDispatchToProps(dispatch) {
    return {
        executeBlockAction: () => dispatch(executeBlockAction(USERS_FORM_DIALOG)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersFormDialogContainer);
